import visit from 'unist-util-visit';
import search from 'nlcst-search'
import findAfter from 'unist-util-find-after';
import { TextAnalysis, TextAnalysisCategory, TextAnalysisResult } from '../SermonAnalyzer';

export default function PassiveVoice() {

	let verbs: string[] = ['am', 'are', 'were', 'being', 'is', 'been', 'was', 'be', "got"]
	let passiveVoiceCount: number = 0;
  	let totalSentanceCount: number = 0;

	return transformer;

	function transformer(tree: any, file: any) {
		search(tree, verbs, searcher);

		function searcher(match: any, index: any, parent: any, phrase: any) {
			let nodeAfter = findAfter(parent, index, "WordNode");

			if (!nodeAfter) {
				return;
			}

			if (nodeAfter.data.partOfSpeech === "VBN") {
				passiveVoiceCount++
			}
		}

		visit(tree, 'SentenceNode', increment)

		function increment(sentence: any) {
			totalSentanceCount++;
			return visit.SKIP
		}

		if (totalSentanceCount === 0) {
			return;
		}

		let passiveAvg: number = Math.round((passiveVoiceCount / totalSentanceCount) * 100);

		let passivePercentage: TextAnalysis = getPassiveText(passiveAvg);

		if (passivePercentage.result === TextAnalysisResult.improvement) {
			file.improvements.push(passivePercentage);
		} else {
			file.goodResults.push(passivePercentage)
		}
	}

	function getPassiveText(percentage: number) {
		let result: TextAnalysis = { title: TextAnalysisCategory.passive_voice, displayText: "", helperText: "Passive voice is calulated using the form of “to be” + past participle"};
		
		if (percentage > 10) {
			result.displayText = `${percentage}% of your sentences contain passive voice. Instead, try to use active words and sentences to make your preaching stronger, more direct, and more active.`;
			result.result = TextAnalysisResult.improvement;
		} else if (percentage === 0) {
			result.displayText = `Great! None of your sentences contain passive voice.`;
			result.result = TextAnalysisResult.goodResult;
		} else {
			result.displayText = `Great work, only ${percentage}% of your sentences contain passive voice. You’re using active expressions in your sermon which means you’re crafting a message for big impact. Keep going!`;
			result.result = TextAnalysisResult.goodResult;
		}
		return result;
	}
}
